import '../sass/frontend.scss';

jQuery(function(){

 // Todo: Move code below into separate classes

 jQuery(document).ready(function($) {

  // Show gift card input when link is clicked
  $('#swoo-show-gift-card').on('click', function() {
    $('#swoo-gift-card-pro .input-group').removeClass('hidden');
  });

  // Update gift card AJAX on shipping method click
  $('form.checkout').on('change', 'input[name^="shipping_method"]', function () {
    setTimeout(function() {
     updateGiftCardAjax(false);
    }, 1000);
  });

  $('#update_gift_card').on('click', function() {
   updateGiftCardAjax(true);
  });

  /**
   *
   * @param {boolean} reloadCheckout
   */
  function updateGiftCardAjax(reloadCheckout) {
   let giftCardCode = $('#swoo-gift-card-pro-input').val();
   $.ajax({
    type: 'POST',
    url: wc_checkout_params.ajax_url,
    data: {
     action: 'update_gift_card',
     gift_card_code: giftCardCode,
     nonce: customAjaxParams.nonce,
    },
    success: (response) => {
     const $balanceDiv = jQuery('#swoo-gift-card-pro-balance');
     $balanceDiv.show();
     if (response.success) {
      jQuery('#swoo-gift-card-pro-balance-now').html(
          response.data.balance_now
      );
      jQuery('#swoo-gift-card-pro-balance-after-purchase').html(
          response.data.balance_after_purchase
      );
      jQuery('#swoo-gift-card-pro-amount-to-spend').html(
          response.data.amount_to_spend
      );
      $balanceDiv.find('.error-box').hide();
      $balanceDiv.find('.success-box').show();
     } else if (giftCardCode.trim()) {
      $balanceDiv.find('.success-box').hide();
      $balanceDiv.find('.error-box').show();
     }
     if (reloadCheckout) {
      jQuery('body').trigger('update_checkout');
     }
    },
   });
  }
 });

});
